function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("style", {
  type: "text/css"
}, "\n\t.st0{fill:#FFFFFF;}\n\t.st1{fill:#1D1D1B;}\n");

var _ref3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
  className: "st0",
  cx: 30.5,
  cy: 30.5,
  r: 30.5
}), /*#__PURE__*/React.createElement("g", {
  id: "XMLID_00000101086924165676873370000004081249734373782173_"
}, /*#__PURE__*/React.createElement("path", {
  id: "XMLID_00000113343625309379707700000000464771855636368055_",
  className: "st1",
  d: "M22.1,30.2h2.2v0.9c2,0.2,4.3,0.3,6.8,0.3 c0,0,0,0,0,0c1.7,0,3.6-0.1,5.5-0.2v-1H39v0.7c0.5-0.1,1.2-0.1,1.7-0.2V9.2H39v1.4h-2.4V9.2H24.4v1.4h-2.2V9.2h-1.9v21.5 c0.5,0.1,1.2,0.1,1.9,0.2V30.2z M36.6,12.3H39V15h-2.4V12.3z M36.6,16.7H39v2.9h-2.4V16.7z M36.6,21.3H39V24h-2.4V21.3z  M36.6,25.7H39v2.7h-2.4V25.7z M22.1,12.3h2.2V15h-2.2V12.3z M22.1,16.7h2.2v2.9h-2.2V16.7z M22.1,21.3h2.2V24h-2.2V21.3z  M22.1,25.7h2.2v2.7h-2.2V25.7z"
}), /*#__PURE__*/React.createElement("path", {
  id: "XMLID_00000049908535024398550090000010260563803020231561_",
  className: "st1",
  d: "M46.7,20.4h-4.1c-0.6,0-1,0.5-1,1 c0,0.6,0.5,1,1,1h1.2l0,8.9c-0.2,0-9,1.2-12.5,1.2c0,0,0,0,0,0c-7.5,0-13.6-1.1-13.7-1.1c0,0-0.1,0-0.1,0v-9h1.1c0.6,0,1-0.5,1-1 c0-0.6-0.5-1-1-1h-4.1c-0.6,0-1,0.5-1,1c0,0.6,0.5,1,1,1h1v10.7c0,0,0,0.1,0,0.1v0.1h0c0.1,0.7,0.6,1.4,1.4,1.6 c0.1,0,1.8,0.3,4.4,0.6l7.8,8l-7.9,8.2h3.1l6.3-6.6l6.3,6.6h3.1l-7.9-8.2l7.8-8.1c1.4-0.2,2.9-0.4,4.4-0.6 c0.7-0.1,1.3-0.6,1.5-1.2v-1.3v-9.9h1c0.6,0,1-0.5,1-1C47.7,20.9,47.2,20.4,46.7,20.4z M30.5,42l-5.9-6.1c2,0.1,4.2,0.2,6.6,0.2 c0,0,0,0,0,0c1.6,0,3.4,0,5.2-0.2L30.5,42z"
}))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M77.8,51.1c2.2-1.1,4.1-6.4,4.1-20.5V19.1c0-4.3-1.8-8.1-4.1-9.2h12.7l10.3,25.3L110,9.9h12.8 c-2.2,1.1-4.1,4.9-4.1,9.2v22.7c0,4.3,1.6,8.1,3.9,9.2h-16.4c2.3-1.1,3.9-4.9,3.9-9.2V17L97.7,50.9L84.4,18.5v12.1 c0,14.2,3.9,19.4,6.2,20.5H77.8z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M125.2,36.8c0-8.6,6.2-14.6,14.8-14.6c8.6,0,14.9,6,14.9,14.6c0,8.6-6.2,14.7-14.9,14.7 C131.5,51.5,125.2,45.4,125.2,36.8z M146.4,36.8c0-7.8-2.2-12.9-6.3-12.9c-4,0-6.2,5.2-6.2,12.9c0,7.8,2.2,12.9,6.2,12.9 C144.1,49.7,146.4,44.6,146.4,36.8z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M164,51.1c0.7-0.4,1-1.2,1-2.4c0-1.6-0.6-3.8-1.4-6.1l-3.8-11c-1.4-3.9-3.1-7.4-5.5-8.4h13.7 c-0.8,0.4-1.1,1.3-1.1,2.5c0,1.6,0.6,3.7,1.3,5.9l4.6,13.8l2.4-7.5c1.1-3.5,1.7-6.5,1.7-9.1s-0.7-4.5-2.1-5.5h11.1 c-3.3,1.5-6.4,8.7-8.5,14.6l-1.7,4.8c-0.7,2.1-1.3,4.3-1.3,5.9c0,1.2,0.3,2.2,1.1,2.6H164z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M185.6,51.1c2.1-1.1,2.5-4.6,2.5-8.6v-8c0-4.1-0.4-7.6-2.5-8.6c4.1-0.8,7.2-2.1,10.5-4v20.6 c0,4.1,0.5,7.6,2.6,8.6H185.6z M186.8,14c0-2.8,1.9-4.5,4.9-4.5c3,0,4.9,1.8,4.9,4.5c0,2.8-1.9,4.5-4.9,4.5 C188.7,18.6,186.8,16.8,186.8,14z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M200.7,36.8c0-8.6,6.2-14.6,14.2-14.6c7.9,0,11.3,4.6,11.3,7.9c0,8.8-14.8,6.4-14.8,14.8c0,3.1,2,4.8,4.8,4.8 c3.9,0,5.9-4.2,6.5-6.6c1.2,0.2,2.6,1.2,2.6,2.9c0,2.2-3.4,5.5-10.1,5.5C206.9,51.5,200.7,45.4,200.7,36.8z M218.7,28.6 c0-3.1-1.4-4.8-3.5-4.8c-3.6,0-6.1,5.2-6.1,12.9c0,2.3,0.3,4.5,0.9,6.4C210.9,37.1,218.7,35,218.7,28.6z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M230.4,51.1c2.3-1.1,3.9-4.9,3.9-9.2V19.1c0-4.3-1.8-8.1-4.1-9.2h18.4c10.5,0,15.9,3.8,15.9,9.6 c0,12.9-21.7,8.5-21.7,22.4c0,4.6,2.4,8.1,4.6,9.2H230.4z M242.8,35.3c3.3-6.5,12.1-7.2,12.1-16.1c0-4.5-2.5-7.5-6.1-7.5 c-3.7,0-5.9,2.7-5.9,7.4V35.3z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M266.1,51.1c2.1-1.1,2.5-4.6,2.5-8.6v-8c0-4.1-0.4-7.6-2.5-8.6c4.1-0.8,7.2-2.1,10.5-4v20.6 c0,4.1,0.5,7.6,2.6,8.6H266.1z M267.2,14c0-2.8,1.9-4.5,4.9-4.5c3,0,4.9,1.8,4.9,4.5c0,2.8-1.9,4.5-4.9,4.5 C269.1,18.6,267.2,16.8,267.2,14z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M280.4,51.1c3.3-1.1,7.5-5.2,11.8-11.3l0.6-0.8l-4.4-7.4c-2.4-3.9-4.9-7.4-7.8-8.4h14.4 c-0.5,0.4-0.6,0.9-0.6,1.5c0,1.6,1.4,4,3.2,6.9l0.8,1.4c2-3.2,3-5.8,3-7.6c0-1.1-0.3-1.8-0.9-2.2h11.3c-3.3,1.1-7.5,5.2-11.8,11.3 l-0.3,0.4l4.9,7.8c2.5,4,5.2,7.5,8.1,8.5h-15.1c0.5-0.5,0.7-1.1,0.7-1.7c0-1.6-1.4-3.9-3-6.8l-1.1-1.7c-1.8,3-2.6,5.5-2.6,7.3 c0,1.4,0.5,2.4,1.3,2.9H280.4z"
})));

var SvgMovieLogo = function SvgMovieLogo(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "308px",
    height: "60px",
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 312 61",
    style: {
      enableBackground: "new 0 0 312 61"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgMovieLogo, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/movie_logo.500e4036.svg";
export { ForwardRef as ReactComponent };